export class MediaFile {

      id: string;
      storage_uri: string | null;
      file_type: string;
      name: string;
      /**
       * A URL that is still fetchable weeks from now.
       *
       * `storage_uri` is presigned and lasts six hours, which is right for showing somebody
       * the file they just uploaded and wrong for anything saved into artwork: a printer
       * fetches a postcard's images when it renders the piece, long after. Anything written
       * into saved HTML must use this one.
       */
      artwork_url: string | null;

    constructor(data?: Partial<MediaFile>) {
      this.id = data?.id || "";
      this.storage_uri = data?.storage_uri || null;
      this.file_type = data?.file_type || "";
      this.name = data?.name || "";
      this.artwork_url = data?.artwork_url || null;
    }
  }
  